import React from "react";
import {
  FaUserPlus,
  FaBullhorn,
  FaHandshake,
  FaCreditCard,
  FaShieldAlt,
  FaStar,
} from "react-icons/fa";

function SecureEscrow() {
  const services = [
    {
      title: "User Registration",
      desc: "Traders create an account on the P2P platform and undergo verification through Know Your Customer (KYC) processes, if required.",
      icon: <FaUserPlus />,
    },
    {
      title: "Posting Offers",
      desc: "Users who wish to buy or sell crypto can post offers specifying the price, amount, and preferred payment method (e.g., bank transfer, PayPal, or even cash).",
      icon: <FaBullhorn />,
    },
    {
      title: "Matching Buyers and Sellers",
      desc: "When a buyer finds a suitable offer, they initiate a trade. The platform then locks the cryptocurrency from the seller in an escrow system to ensure security until the transaction is complete.",
      icon: <FaHandshake />,
    },
    {
      title: "Payment Processing",
      desc: "The buyer pays the seller using the agreed-upon payment method outside the platform. Once the payment is confirmed by the seller, the cryptocurrency held in escrow is released to the buyer.",
      icon: <FaCreditCard />,
    },
    {
      title: "Escrow Protection",
      desc: "If there is any dispute or delay in the transaction, the platform’s escrow service steps in to mediate and ensure a fair resolution.",
      icon: <FaShieldAlt />,
    },
    {
      title: "Ratings and Reviews",
      desc: "After the transaction is complete, both parties can leave feedback on the platform, building trust within the user community.",
      icon: <FaStar />,
    },
  ];
  return (
    <>
      {/* <div className="services-style-seven-area default-padding-bottom pt-220 pt-md-110 pt-xs-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="site-heading text-center">
                <h4 className="sub-title">Services</h4>
                <h2 className="title split-text-right split-text-in-right">
                  P2P Exchange Order & Trade Lifecycle
                </h2>
                <p>
                  A P2P (peer-to-peer) crypto exchange operates by allowing
                  users to trade cryptocurrencies directly with one another
                  without the need for an intermediary or centralized authority.
                  Here’s how it works:
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="services-style-seven-items">
                <div className="accordion" id="faqAccordion">
                  <div className="services-style-seven-item">
                    <h2 className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        <FaUserPlus className="me-2" />
                        User Registration
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#faqAccordion"
                    >
                      <div className="accordion-body">
                        <div className="info">
                          <p>
                            Traders create an account on the P2P platform and
                            undergo verification through Know Your Customer
                            (KYC) processes, if required.
                          </p>
                        </div>
                        <div className="thumb">
                          <img
                            src="https://validthemes.net/site-template/robok/assets/img/services/11.jpg"
                            alt="Image Not Found"
                          />
                        </div>
                        <ul className="list-style-two">
                          <li>Robotic Process Automation</li>
                          <li>Natural Language Processing</li>
                          <li>Data Privacy Ethics</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="services-style-seven-item">
                    <h2 className="accordion-header" id="headingTwo">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        <FaBullhorn className="me-2" />
                        Posting Offers
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#faqAccordion"
                    >
                      <div className="accordion-body">
                        <div className="info">
                          <p>
                            Users who wish to buy or sell crypto can post offers
                            specifying the price, amount, and preferred payment
                            method (e.g., bank transfer, PayPal, or even cash).
                          </p>
                        </div>
                        <div className="thumb">
                          <img
                            src="https://validthemes.net/site-template/robok/assets/img/services/22.jpg"
                            alt="Image Not Found"
                          />
                        </div>
                        <ul className="list-style-two">
                          <li>Robotic Process Automation</li>
                          <li>Natural Language Processing</li>
                          <li>Data Privacy Ethics</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="services-style-seven-item">
                    <h2 className="accordion-header" id="headingThree">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        <FaHandshake className="me-2" />
                        Matching Buyers and Sellers
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#faqAccordion"
                    >
                      <div className="accordion-body">
                        <div className="info">
                          <p>
                            When a buyer finds a suitable offer, they initiate a
                            trade. The platform then locks the cryptocurrency
                            from the seller in an escrow system to ensure
                            security until the transaction is complete.
                          </p>
                        </div>
                        <div className="thumb">
                          <img
                            src="https://validthemes.net/site-template/robok/assets/img/services/33.jpg"
                            alt="Image Not Found"
                          />
                        </div>
                        <ul className="list-style-two">
                          <li>Robotic Process Automation</li>
                          <li>Natural Language Processing</li>
                          <li>Data Privacy Ethics</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="services-style-seven-item">
                    <h2 className="accordion-header" id="headingFour">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        <FaCreditCard className="me-2" />
                        Payment Processing
                      </button>
                    </h2>
                    <div
                      id="collapseFour"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingFour"
                      data-bs-parent="#faqAccordion"
                    >
                      <div className="accordion-body">
                        <div className="info">
                          <p>
                            The buyer pays the seller using the agreed-upon
                            payment method outside the platform. Once the
                            payment is confirmed by the seller, the
                            cryptocurrency held in escrow is released to the
                            buyer.
                          </p>
                        </div>
                        <div className="thumb">
                          <img
                            src="https://validthemes.net/site-template/robok/assets/img/services/44.jpg"
                            alt="Image Not Found"
                          />
                        </div>
                        <ul className="list-style-two">
                          <li>Robotic Process Automation</li>
                          <li>Natural Language Processing</li>
                          <li>Data Privacy Ethics</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="services-style-seven-item">
                    <h2 className="accordion-header" id="headingFive">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFive"
                        aria-expanded="false"
                        aria-controls="collapseFive"
                      >
                        <FaShieldAlt className="me-2" />
                        Escrow Protection
                      </button>
                    </h2>
                    <div
                      id="collapseFive"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingFive"
                      data-bs-parent="#faqAccordion"
                    >
                      <div className="accordion-body">
                        <div className="info">
                          <p>
                            If there is any dispute or delay in the transaction,
                            the platform’s escrow service steps in to mediate
                            and ensure a fair resolution.
                          </p>
                        </div>
                        <div className="thumb">
                          <img
                            src="https://validthemes.net/site-template/robok/assets/img/services/44.jpg"
                            alt="Image Not Found"
                          />
                        </div>
                        <ul className="list-style-two">
                          <li>Robotic Process Automation</li>
                          <li>Natural Language Processing</li>
                          <li>Data Privacy Ethics</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="services-style-seven-item">
                    <h2 className="accordion-header" id="headingSix">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSix"
                        aria-expanded="false"
                        aria-controls="collapseSix"
                      >
                        <FaStar className="me-2" />
                        Ratings and Reviews
                      </button>
                    </h2>
                    <div
                      id="collapseSix"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingSix"
                      data-bs-parent="#faqAccordion"
                    >
                      <div className="accordion-body">
                        <div className="info">
                          <p>
                            After the transaction is complete, both parties can
                            leave feedback on the platform, building trust
                            within the user community.
                          </p>
                        </div>
                        <div className="thumb">
                          <img
                            src="https://validthemes.net/site-template/robok/assets/img/services/44.jpg"
                            alt="Image Not Found"
                          />
                        </div>
                        <ul className="list-style-two">
                          <li>Robotic Process Automation</li>
                          <li>Natural Language Processing</li>
                          <li>Data Privacy Ethics</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <section className="defi-section">
        <div className="container">
          {/* HEADER */}
          <div className="defi-header">
            <h4 className="defi-subtitle">Our Services</h4>
            <h2 className="defi-title">P2P Exchange Order & Trade Lifecycle</h2>
            <p className="defi-desc">
              A P2P (peer-to-peer) crypto exchange operates by allowing users to
              trade cryptocurrencies directly with one another without the need
              for an intermediary or centralized authority. Here’s how it works:
            </p>
          </div>

          {/* GRID */}
          <div className="defi-grid">
            {services.map((service, index) => (
              <div className="defi-card" key={index}>
                <div className="card-glow"></div>

                <div className="defi-icon">{service.icon}</div>

                <h5 className="defi-card-title">{service.title}</h5>
                <p className="defi-card-desc">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default SecureEscrow;
